import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  DropDown,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { Col, List, Radio, Row } from "antd";
import flower from "../../../assets/staticImages/flower.png";
import event from "../../../assets/staticImages/event.png";
import food from "../../../assets/staticImages/food.png";
import decor from "../../../assets/staticImages/decor.png";
import flower1 from "../../../assets/staticImages/flower1.png";
import flower2 from "../../../assets/staticImages/flower2.png";
import Modal from "../../../components/modal/Modal";
// import categoryImg from "../../../assets/category.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { roles } from "../../../config/roles";
import styles from "./inspirational.module.css";
import Storage from "../../../utills/AsyncStorage";
import { useDispatch, useSelector } from "react-redux";
import { InspirationalGalleryMiddleware } from "../../../Store/Middlewares/InspirationalGalleryMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const InspirationalGallery = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [category, setCategory] = useState("");
  const [newCategoryName, setnewCategoryName] = useState(null);
  const [allClientCategories, setAllClientCategories] = useState();
  const [search, setSearch] = useState("");
  const [value, setValue] = useState(1);
  // const [categoryDetails, setCategoryDetails] = useState();
  const [categoryModal, setCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState(false);
  const EventCategory = useSelector(
    (state) => state.EventReducer.EventDetails?.inspiration_gallery_categories
  );
  // const EventCategory = useSelector((state) => state?.GeneralReducer?.GeneralTypes);
  const EventID = useSelector((state) => state.EventReducer.EventDetails?.id);
  const GalleryData = useSelector(
    (state) => state.InspirationalGalleryReducer.Gallery
  );
  // console.log('EventCategory', EventCategory);
  // console.log('stateInspiration======>>>>>', state);
  // const role = localStorage.getItem("role");

  const role = Storage.getERole("@role");

  const handleChangeCategory = (value) => {
    setCategory(value);
  };
  useEffect(() => {
    role == roles?.client || role == roles.coHost
      ? getClientData()
      : getVendorData();
  }, []);

  const getClientData = () => {
    let data = {
      event_id: state?.eventData?.id,
      image_name: search ? search : undefined,
      category_id: category?.id ? category?.id : undefined,
    };
    dispatch(InspirationalGalleryMiddleware.getAllClientCategories(data));
    // setAllClientCategories(data)
  };

  const getVendorData = () => {
    let data = {
      event_id: state?.eventData?.id,
      image_name: search ? search : undefined,
      category_id: category?.id ? category?.id : undefined,
    };
    dispatch(InspirationalGalleryMiddleware.getAllVendorCategories(data));
  };
  const onSearchGallery = () => {
    if (!category) {
      return dispatch(
        showAlert({ type: "Error", message: "Please select category" })
      );
    }
    let data = {
      event_id: state?.eventData?.id,
      image_name: search ? search : undefined,
      category_id: category?.id,
    };
    role == roles?.client
      ? dispatch(InspirationalGalleryMiddleware.getAllClientCategories(data))
      : dispatch(InspirationalGalleryMiddleware.getAllVendorCategories(data));
  };
  const onCreateNewCategory = () => {
    if (!newCategoryName) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please Enter Category",
        })
      );
    } else if (
      EventCategory.find(
        (e) => e.name.toLowerCase() == newCategoryName.toLowerCase()
      )
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: `${newCategoryName} already exist`,
        })
      );
    } else {
      setCategoryModal(false);
      dispatch(
        InspirationalGalleryMiddleware.createCategory({
          name: newCategoryName,
        })
      )
        .then(
          (data) =>
            navigation("/events/createInspirationalGallery", {
              state: {
                headrTitle: "Inspirational Gallery",
                event_id: state?.eventData?.id,
                category: { category_id: data.id, category_name: data.name },
              },
            }),
          setnewCategoryName(null)
        )
        .catch((err) => console.log("err", err));
    }
  };

  const onNext = () => {
    if (!categoryId.id) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please Select Category",
        })
      );
    } else {
      navigation("/events/createInspirationalGallery", {
        state: {
          headrTitle: "Inspirational Gallery",
          event_id: state?.eventData?.id,
          category: {
            category_id: categoryId.id,
            category_name: categoryId.val,
          },
        },
      });
      setnewCategoryName(null);
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
  };


  const renderCategory = (item, index) => {
    return (
      <div
        key={item?.id}
        className={styles.listItem}
        onClick={() =>
          navigation("/events/inspirationalGalleryDetails", {
            state: {
              headrTitle: "Inspirational Gallery",
              item,
              event_id: state?.eventData?.id,
            },
          })
        }
      >
        <TextComponent text={item?.category_name} textClass={styles.listText} />
        <img src={item?.images[0]?.image} alt={'image not loaded'} className={styles.listImg} />
      </div>
    );
  };


 

  return (
    <div className={styles.mainCon}>
      <div
        className={styles.head}
        style={{
          justifyContent:
            role === roles.vendor || role === roles.staff
              ? "center"
              : "space-between",
        }}
      >
        <div className={styles.headLeft}>
          <div className={styles.searchItem}>
            <DropDown
              placeholder={"category"}
              stylesClass={styles.dropdown}
              name={"category"}
              onChange={handleChangeCategory}
              object={EventCategory}
            />
          </div>
          <div className={styles.searchItem}>
            <SearchInput
              placeholder={"Search"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className={styles.hL_right}>
            <SubmitButton title={"Search"} onClick={onSearchGallery} />
          </div>
        </div>
        {role === roles.vendor ||
        role === roles.coHost ||
        role === roles.staff ? (
          <></>
        ) : (
          <div className={styles.headRight}>
            <SubmitButton
              title={"Category"}
              btnClass={styles.btn}
              onClick={() => setCategoryModal(true)}
            />
          </div>
        )}
      </div>
      <div className={styles.textCon}>
        <TextComponent
          text={"Wedding Beauty Photos"}
          textClass={styles.textHeading}
        />
        <TextComponent
          text={
            "in this wedding photo gallery, you will find images of wedding hairstyles and makeup that can inspire your own look, getting-ready photos, and more."
          }
          textClass={styles.text}
        />
      </div>
      <List
        className={styles.list}
        grid={{ xxl: 4, xl: 4, lg: 2, xs: 1, md: 3 }}
        itemLayout="horizontal"
        dataSource={GalleryData}
        renderItem={renderCategory}
      />
      {/* <div className={styles.categoryBtn}>
        <SubmitButton title={"More Categories"} btnClass={styles.Cbtn} />
      </div> */}
      {categoryModal && (
        <Modal
          isModalOpen={categoryModal}
          setIsModalOpen={setCategoryModal}
          closable={true}
          className={styles.modal}
        >
          <div className={styles.modalCon}>
            <div className={styles.modalConLeft}>
              <svg
                viewBox="0 0 375 376"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M156.689 47.499H63.1888C59.0558 47.499 55.0922 49.1452 52.1697 52.0755C49.2473 55.0057 47.6055 58.98 47.6055 63.124V156.874C47.6055 161.018 49.2473 164.992 52.1697 167.923C55.0922 170.853 59.0558 172.499 63.1888 172.499H156.689C160.822 172.499 164.785 170.853 167.708 167.923C170.63 164.992 172.272 161.018 172.272 156.874V63.124C172.272 58.98 170.63 55.0057 167.708 52.0755C164.785 49.1452 160.822 47.499 156.689 47.499ZM312.522 203.749H219.022C214.889 203.749 210.925 205.395 208.003 208.325C205.081 211.256 203.439 215.23 203.439 219.374V313.124C203.439 317.268 205.081 321.242 208.003 324.173C210.925 327.103 214.889 328.749 219.022 328.749H312.522C316.655 328.749 320.619 327.103 323.541 324.173C326.464 321.242 328.105 317.268 328.105 313.124V219.374C328.105 215.23 326.464 211.256 323.541 208.325C320.619 205.395 316.655 203.749 312.522 203.749ZM265.772 47.499C231.395 47.499 203.439 75.5303 203.439 109.999C203.439 144.468 231.395 172.499 265.772 172.499C300.149 172.499 328.105 144.468 328.105 109.999C328.105 75.5303 300.149 47.499 265.772 47.499ZM109.939 203.749C75.562 203.749 47.6055 231.78 47.6055 266.249C47.6055 300.718 75.562 328.749 109.939 328.749C144.316 328.749 172.272 300.718 172.272 266.249C172.272 231.78 144.316 203.749 109.939 203.749Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </div>

            <div className={styles.modalConRight}>
              <TextComponent
                text={"Please Create Or Select Category"}
                textClass={styles.modalHeading}
              />
              <div>
                <Radio.Group onChange={onChange} value={value}>
                  <Radio value={1}>Create</Radio>
                  <Radio value={2}>Select</Radio>
                </Radio.Group>
              </div>
              {value == 1 ? (
                <InputField
                  label="Create Category"
                  placeholder={"category"}
                  value={newCategoryName}
                  onChange={(e) => setnewCategoryName(e.target.value)}
                />
              ) : (
                <DropDown
                  placeholder={"category"}
                  label="Select Category"
                  stylesClass={styles.dropdown}
                  name={"category"}
                  onChange={(values) => setCategoryId(values)}
                  object={EventCategory}
                />
              )}
              <div className={styles.modalBtns}>
                <SubmitButton
                  onClick={() =>
                    value == 1 ? onCreateNewCategory() : onNext()
                  }
                  textClass={styles.modalBtnTxt}
                  title={value == 1 ? "Create" : "Next"}
                  btnClass={styles.modalBtn}
                />
                <SubmitButton
                  textClass={styles.modalBtnTxt}
                  outline={true}
                  title={"Cancel"}
                  btnClass={styles.modalBtn}
                  onClick={() => {
                    setCategoryModal(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
export default InspirationalGallery;
